import { getMusilinksHistoryAdminAPI, getMusilinksUsersAdminAPI } from "./api"

export function getMusilinksHistoryAdmin(data) {
    return new Promise((resolve, reject) => {
        getMusilinksHistoryAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}

export function getMusilinksUsersAdmin(data) {
    return new Promise((resolve, reject) => {
        getMusilinksUsersAdminAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}
